
import { ITDisplayPrice, ITDisplayPriceNotRounded, ITDisplayFinalPrice, ITDisplayEditFinalPrice, OrderDisplayEditFinalPriceBase, ITDisplayInitialPrice, OrderDisplayInitiaPrice, ITDisplayImage, ITBooleanRender, ITDeleteRowSell } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { ITInputSelectWithSeachBar, ITInputQuantityRefund, ITInputSelectWarehouses } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Inputs'
import { DictionaryComponents } from '../../../../utils/globals/types'
import { SellSelectedCheckbox, SellRefundCheckbox } from '../../../sells/components'
import { OrderRectangularInputSmall, OrderEditableText, OrderInputPrice, OrderSaveRemainingProduct, ITOrderBooleanRectangle, OrderCustomSelectBlockedItemsSearchbar, OrderInputQuantity, OrderInputQuantity2, OrderInputDiscount, OrderInputCalendar, OrderRefundProduct, OrderInputPercentage, OrderEditableName } from '../OrderLayout/OrderTable/TableComponents/Inputs'
import OrderSearchProductInput, { OrderSearchProductInputName, OrderSearchProductInputReferenceAndName, OrderSearchProductInputCreate } from '../OrderLayout/OrderTable/TableComponents/Inputs/OrderSearchProductInput'
import OrderChangePackUnit from '../OrderLayout/OrderTable/TableComponents/OrdeChangePackUnit'
import OrderEditAddonProduct from '../OrderLayout/OrderTable/TableComponents/OrderEditAddonProduct'
import OrderEditProduct from '../OrderLayout/OrderTable/TableComponents/OrderEditProduct'
import OrderPrintTags from '../OrderLayout/OrderTable/TableComponents/OrderPrintTags'
import OrderSyncProductPrice from '../OrderLayout/OrderTable/TableComponents/OrderSyncProductPrice'
import { OrderDragHandle } from '../OrderLayout/OrderTable/TableComponents/Sorts'
import InputTableSellTicket from './InputTableSellTicket'
import ModalsOrderSellTicketLayout from './ModalsOrderSellTicketLayout'
import { InputTableSellTicketFooterFullProps, InputTableSellTicketLayoutProps } from './types'
import useSellTicketLayoutTableLogic from './useSellTicketLayoutTableLogic'

interface OrderSellTicketTPVLayoutProps extends InputTableSellTicketLayoutProps {
    title: string
}

const OrderSellTicketTPVLayout: React.FC<OrderSellTicketTPVLayoutProps> = ({ ...rest }) => {
    return (
        <InputTableSellTicket {...rest} components={sellTicketLayoutComponents} hookFunction={useSellTicketLayoutTableLogic} completeData={rest.completeData as any} setCompleteData={rest.setCompleteData as any} TableChildren={OrderTableChildren}/>
    )
}

const OrderTableChildren: React.FC<InputTableSellTicketFooterFullProps> = ({ completeData, eventFunctions, ...rest }) => {
    return (
        <ModalsOrderSellTicketLayout myOrderId={completeData?.header?.id} openModal={null} headerData={completeData?.header || {}} deleteLine={eventFunctions.deleteLine} onChangeAdd={eventFunctions.onChangeAdd} onChangeFetch={eventFunctions.onChangeFetch} onChangeUpdate={eventFunctions.onChangeUpdate} completeData={completeData || {} as any}{...rest} />
    )
}

export const sellTicketLayoutComponents: DictionaryComponents = {
    ITRectangularInput: OrderRectangularInputSmall,
    ITEditableText: OrderEditableText,
    ITEditableName: OrderEditableName,
    ITInputNumeric: OrderInputPrice,
    ITInputPercentage: OrderInputPercentage,
    OrderSearchProductInput: OrderSearchProductInput,
    OrderSearchProductInputName: OrderSearchProductInputName,
    OrderSearchProductInputReferenceAndName: OrderSearchProductInputReferenceAndName,
    OrderSearchProductInputCreate: OrderSearchProductInputCreate,
    OrderSaveRemainingProduct: OrderSaveRemainingProduct,
    ITOrderBooleanRectangle: ITOrderBooleanRectangle,
    ITSelectSpecificPriceRule: OrderCustomSelectBlockedItemsSearchbar,
    ITInputQuantity: OrderInputQuantity,
    ITInputQuantity2: OrderInputQuantity2,
    ITInputDiscount: OrderInputDiscount,
    ITInputCalendar: OrderInputCalendar,
    ITDragHandle: OrderDragHandle,
    ITDisplayPrice: ITDisplayPrice,
    ITInputPrice: OrderInputPrice,
    ITDisplayPriceNotRounded: ITDisplayPriceNotRounded,
    ITDisplayFinalPrice: ITDisplayFinalPrice,
    ITDisplayEditFinalPrice: ITDisplayEditFinalPrice,
    ITDisplayEditFinalPriceBase: OrderDisplayEditFinalPriceBase,
    ITDisplayInitialPrice: ITDisplayInitialPrice,
    ITDisplayInitialPriceBase: OrderDisplayInitiaPrice,
    OrderEditProduct: OrderEditProduct,
    OrderSyncProductPrice: OrderSyncProductPrice,
    OrderEditAddonProduct: OrderEditAddonProduct,
    ITDisplayImage: ITDisplayImage,
    ITBooleanRender: ITBooleanRender,
    ITInputSelectWithSeachBar: ITInputSelectWithSeachBar,
    DeleteComponent: ITDeleteRowSell,
    CheckboxComponent: SellSelectedCheckbox,
    SellRefundCheckbox,
    OrderChangePackUnit,
    OrderRefundProduct,
    ITInputQuantityRefund,
    OrderPrintTags,
    ITInputSelectWarehouses,
}

export default OrderSellTicketTPVLayout